import { Box, Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import CongratsImage from 'src/assets/images/first-time-setup-congrats.avif';
import FullBleedHero from 'src/components/FullBleedHero';
import VisitCard from 'src/components/VisitCard';
import { useOnboardingWorkflow } from 'src/contexts/OnboardingWorkflowContext';
import useResponsive from 'src/hooks/useResponsive';

export const Route = createFileRoute('/(app)/onboarding/congrats')({
    component: VisitCongratsComponent,
});

function VisitCongratsComponent() {
    const navigate = useNavigate();
    const { spacing } = useTheme();

    const { createdVisitSchedule } = useOnboardingWorkflow();
    const { isMobile } = useResponsive();

    return (
        <Stack
            sx={{
                height: isMobile ? '100svh' : spacing(80),
                justifyContent: 'space-between',
                gap: 2,
            }}
        >
            <FullBleedHero
                sxProps={{
                    backgroundImage: `url(${CongratsImage})`,
                    backgroundSize: isMobile ? 'contain' : 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: isMobile ? 'top right' : 'top left',
                }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: 0, width: '100%' }}>
                    <Stack sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                        {createdVisitSchedule && <VisitCard visit={createdVisitSchedule} />}
                    </Stack>
                </Box>
            </FullBleedHero>

            <Stack sx={{ gap: 4, pb: isMobile ? 2.5 : 0 }}>
                <Stack sx={{ gap: 2, alignItems: 'center', textAlign: 'center' }}>
                    <Typography variant="h1" sx={{ fontWeight: 600 }}>
                        You&apos;re on your way.
                    </Typography>

                    <Typography variant="body1">
                        Your Sage Home account is ready to keep everyone informed.
                    </Typography>
                    <Typography variant="body1">
                        Add care information, invite more members, and manage visits and requests
                        directly from the Homepage.
                    </Typography>
                </Stack>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => navigate({ to: '/home' })}
                >
                    Go to Homepage
                </Button>
            </Stack>
        </Stack>
    );
}
